import {
    WeeklySummaryType,
    FoodLogItemNutritionType,
    DisplayType,
    ScoreType,
    TrafficLightDistributionType,
    CategoryAveragesType,
    CategoryAverageType,
    TrendType,
    WeeklyInsightsType,
    WeeklyNutritionType,
    userType,
} from "../../DTO";
import { Api } from "../api";

interface IWeeklySummaryParams {
    appUser: userType;
    userId: number;
    weekId: number;
}

export const WeeklySummary = (params: IWeeklySummaryParams) => {
    return new Promise<{ weekly_summary: WeeklySummaryType }>((resolve, reject) => {
        const api = new Api({
            method: "get",
            path: `summary/weekly/user/${params.userId}/${params.weekId}`,
            header: {
                Authorization: `Bearer ${params.appUser.access_token}`,
            },
        });

        return api
            .call()
            .then((data: any) =>
                resolve({
                    weekly_summary: convertToWeeklySummaryType(data.data),
                }),
            )
            .catch((err) => reject(err.data.message));
    });
};

export const convertToWeeklySummaryType = (data: any): WeeklySummaryType => {
    const out: WeeklySummaryType = {
        id: data?.id,
        week_id: data?.week_id,
        has_summary: data?.has_summary,
        display: convertToDisplayType(data?.display),
        score: convertToScoreType(data?.score),
        traffic_light_distribution: convertToTrafficLightDistributionType(
            data?.traffic_light_distribution
        ),
        category_averages: convertToCategoryAveragesType(data?.category_averages),
        trend: convertToTrendType(data?.trend),
        insights: convertToWeeklyInsightsType(data?.insights),
        nutrition: convertToWeeklyNutritionType(data?.nutrition),
        generated_at: data?.generated_at,
    };

    return out;
};

const convertToDisplayType = (data: any): DisplayType => {
    return {
        title: data?.title || "",
        light: data?.light || "green",
        color_code: data?.color_code || "#22C55E",
        emoji: data?.emoji || "",
    };
};

const convertToScoreType = (data: any): ScoreType => {
    return {
        total: data?.total || 0,
        max: data?.max || 100,
        percentage: data?.percentage || 0,
    };
};

const convertToTrafficLightDistributionType = (
    data: any
): TrafficLightDistributionType => {
    return {
        green_days: data?.green_days || 0,
        amber_days: data?.amber_days || 0,
        red_days: data?.red_days || 0,
        days_with_data: data?.days_with_data || 0,
        total_days: data?.total_days || 7,
    };
};

const convertToCategoryAveragesType = (data: any): CategoryAveragesType => {
    return {
        carbs: convertToCategoryAverageType(data?.carbs),
        sugar: convertToCategoryAverageType(data?.sugar),
        fiber: convertToCategoryAverageType(data?.fiber),
        protein: convertToCategoryAverageType(data?.protein),
    };
};

const convertToCategoryAverageType = (data: any): CategoryAverageType => {
    return {
        avg_score: data?.avg_score || 0,
        light: data?.light || "green",
    };
};

const convertToTrendType = (data: any): TrendType => {
    return {
        direction: data?.direction || "stable",
        icon: data?.icon || "→",
        score_change: data?.score_change || 0,
        description: data?.description || "",
    };
};

const convertToWeeklyInsightsType = (data: any): WeeklyInsightsType => {
    return {
        weekly_insight: data?.weekly_insight || "",
        worst_category: data?.worst_category || "",
        focus_areas: data?.focus_areas || [],
    };
};

const convertToWeeklyNutritionType = (data: any): WeeklyNutritionType => {
    return {
        totals: convertToNutritionType(data?.totals),
        daily_averages: convertToNutritionType(data?.daily_averages),
    };
};

const convertToNutritionType = (data: any): FoodLogItemNutritionType => {
    return {
        calories: data?.calories || 0,
        protein: data?.protein || 0,
        carbohydrates: data?.carbohydrates || 0,
        fat: data?.fat || 0,
        fiber: data?.fiber || 0,
        sugar: data?.sugar || 0,
        sodium: data?.sodium || 0,
        cholesterol: data?.cholesterol || 0,
        saturated_fat: data?.saturated_fat || 0,
        trans_fat: data?.trans_fat || 0,
    };
};
